<template>
  <v-row class="align-center">
    <v-col cols="3">
      <v-btn
        block
        color="primary"
        :dense="dense"
        :disabled="disabled || isLoading"
        outlined
        text
        @click="onAddClicked"
      >
        <input
          type="file"
          v-show="false"
          accept="image/*"
          ref="uploadInput"
          @change="hasChanged"
        />
        <span
          v-if="spanName"
          class="mr-2"
          >{{ spanName }}
        </span>
        <span
          v-else
          class="mr-2"
        >
          {{ $t("actions.add", { entity: $tc("commons.picture", 1) }) }}
        </span>
        <v-icon>mdi-image-plus</v-icon>
      </v-btn>

      <v-btn
        block
        color="error"
        :dense="dense"
        :disabled="disabled || !hasValue"
        outlined
        text
        @click="onDeleteClicked"
        >{{ $t("actions.delete", { entity: $tc("commons.picture", 1) }) }}</v-btn
      >
    </v-col>

    <v-col cols="9">
      <v-img
        class="full-width-image"
        height="140"
        :src="value"
      />
    </v-col>
  </v-row>
</template>

<script>
import { imageValidator } from "@/utils/validator"

export default {
  name: "ImageInput",
  props: {
    value: {
      type: [String, null],
      required: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    spanName: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasValue() {
      return this.value
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    hasChanged(e) {
      e.target.files.forEach((file, i) => {
        if (file && imageValidator(file)) {
          this.isLoading = true
          let reader = new FileReader()
          reader.addEventListener("load", () => this.update(reader), false)
          reader.readAsDataURL(file)
        }
      })
    },
    onAddClicked() {
      this.$refs.uploadInput.click()
    },
    onDeleteClicked() {
      this.$emit("input", null)
    },
    update(file_reader) {
      this.$emit("input", file_reader.result)
      this.isLoading = false
    }
  }
}
</script>
